import { ErrorHandler, LOCALE_ID, NgModule, inject, provideAppInitializer } from '@angular/core';
import {registerLocaleData} from '@angular/common';
import {StromcheckRoutingModule} from './stromcheck-routing.module';
import {TranslateLoader, provideTranslateService} from '@ngx-translate/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MAT_DATE_LOCALE} from '@angular/material/core';
import {BrowserModule} from '@angular/platform-browser';
import {HttpClient, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import * as Sentry from '@sentry/angular';
import {Router} from '@angular/router';
import localeDE from '@angular/common/locales/de';
import {StromcheckComponent} from './stromcheck.component';
import {StepService} from '../services/step.service';
import {AdvisorSharedModule} from '../advisor.shared.module';
import {PortalService} from '../services/portal.service';
import {EingabeStartComponent} from './eingabe/eingabe.start.component';
import {EingabeStepComponent} from './eingabe/eingabe.step.component';
import {EingabeStepVerbrauchsdatenComponent} from './eingabe/eingabe.step.verbrauchsdaten.component';
import {ErgebnisComponent} from './ergebnis/ergebnis.component';
import {SavingsComponent} from "./ergebnis/savings/savings.component";
import {EMobilityBoxComponent} from "./ergebnis/e-mobility-box/e-mobility-box.component";
import {AnalyseComponent} from "./ergebnis/analyse/analyse.component";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {SafeHtmlPipe} from "../pipe/SafeHtmlPipe";
import {EinstiegComponent} from "./einstieg/einstieg.component";
import {KopfbuehneComponent} from "./kopfbuehne/kopfbuehne.component";

// global definition of language prefix
declare let advisorTranslationPrefix;

// AoT requires an exported function for factories
export function HttpLoaderFactory() {
  const http = inject(HttpClient);
  return {
    getTranslation: (lang: string) => http.get<object>(
      (typeof advisorTranslationPrefix !== 'undefined' ? advisorTranslationPrefix : 'translations/' + PortalService.defaultPortal + '/stromcheck/') + lang + '.json'
    )
  };
}

// load the locales dynamic, based on the users browser language with fallback
const browserLocale = getBrowsersLocale();
switch (browserLocale.substring(0, 2)) {
  case 'de':
    registerLocaleData(localeDE, 'de');
    break;
}

/**
 * returns the users locale from the browser
 */
function getBrowsersLocale() {
  /* tslint:disable:no-string-literal */
  if (navigator['browserLanguage']) {
    return navigator['browserLanguage'];
  }
  else if (navigator.language) {
    return navigator.language;
  }
  /* tslint:enable:no-string-literal */
}

@NgModule({
  declarations: [
    StromcheckComponent,
    EinstiegComponent,
    KopfbuehneComponent,
    EingabeStartComponent,
    EingabeStepComponent,
    EingabeStepVerbrauchsdatenComponent,
    ErgebnisComponent,
    SavingsComponent,
    EMobilityBoxComponent,
    AnalyseComponent,
    SafeHtmlPipe
  ],
  bootstrap: [
    StromcheckComponent
  ],
  imports: [
    BrowserModule,
    StromcheckRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    AdvisorSharedModule,
    MatCheckboxModule
  ],
  providers: [
    {provide: MAT_DATE_LOCALE, useValue: 'de-DE'},
    {provide: LOCALE_ID, useValue: getBrowsersLocale()},
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
        dialogOptions: {
          user: {
            name: 'dummy',
            email: 'dummy@co2online.de'
          }
        }
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    provideAppInitializer(() => {
      const initializerFn = () => {
        inject(Sentry.TraceService)
      };
        return initializerFn();
      }),
    StepService,
        provideTranslateService({loader: {provide: TranslateLoader, useFactory: HttpLoaderFactory}}),
        provideHttpClient(withInterceptorsFromDi())
  ]
})
export class StromcheckModule {
}
